<div class="dialog-container">
    <h2 class="dialog-title">Success</h2>
    <div class="dialog-content">
      {{ data.message }}
    </div>
    <div class="dialog-actions" align="end">
      <button mat-button (click)="closeDialog()">Close</button>
    </div>
  </div>
  